import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    APIS,
    SF_APP_DTL_APRV_INFO,
    SF_APP_RGST_APRV_RSLT,
    SG_APP_DTL_INSC_ATCM,
} from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";

/**
 * LPCO Application Final Approval Result
 * !== LPCO 신청서 최종 승인 결과 ==!
 */
export const OSCI0201014S = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0008", "auth_osci0016"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const { close, postMessage, getParams } = usePopup();
    const params = getParams(); // 부모창에서 전달된 Parameter

    let errmsg: any;

    const [atcmList, setAtcmList] = useState(comnUtils.getGridData([]));
    const [atcmVisible, setAtcmVisible] = useState(false);
    const [sbmtVisible, setSbmtVisible] = useState(false);
    const [exmpnTaxVisible, setExmpnTaxVisble] = useState(false);

    const [excludeAuditCode, setExcludeAuditCode] = useState<any[]>(["VF", "FV", "IP", "RS"]);

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0131" },
            { area: "comnCd", comnCd: "OSC0142" },
        ],
    });

    const form = {
        appDtlAprvInfo: useForm({
            defaultSchema: SF_APP_DTL_APRV_INFO,
        }),
        appRgstAprvRslt: useForm({
            defaultSchema: SF_APP_RGST_APRV_RSLT,
        }),
    };

    /*
     * Register Inspection Result Attachment Files Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Attachment Files List !== 첨부문서 목록 ==!
        appDtlInscAtcm: useGrid({
            defaultSchema: SG_APP_DTL_INSC_ATCM,
            // page: pgeStore?.page,
            // size: pgeStore?.size,
        }),
    };

    /*
     * Application Item Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Application Information !== 신청서 정보 조회 ==!.
        getAppAprvInfo: useFetch({
            api: (data) => APIS.getAppAprvInfo({ reffId: data.appId }),
            onSuccess: (data) => {
                if (data.appAprvInfo!) {
                    form.appRgstAprvRslt.setValues(data.appAprvInfo.content);
                    if (data.appAprvInfo.content.prcssStatCd!) {
                        if (
                            "EF" == params.appInfo.appStatCd &&
                            ("AP" == data.appAprvInfo.content.prcssStatCd ||
                                data.appAprvInfo.content.exmpnTaxTpCd.length > 0)
                        ) {
                            setExmpnTaxVisble(true);
                        } else {
                            setExmpnTaxVisble(false);
                        }
                        setSbmtVisible(true);
                    } else {
                        if ("EF" == params.appInfo.appStatCd) {
                            setExmpnTaxVisble(true);
                        }
                    }
                }
                const nregYn = data?.appAprvInfo?.content?.nregYn || "";
                const prcsRoleTpCd = data?.prcsInfo?.content?.prcsRoleTpCd || "";
                const prevPrcsRoleTpCd = data?.prcsInfo?.content?.prevPrcsRoleTpCd || "";
                if (nregYn === "Y") {
                    setExcludeAuditCode(APIS.getExcludeAuditRsltCdList("NR", prevPrcsRoleTpCd));
                } else {
                    setExcludeAuditCode(APIS.getExcludeAuditRsltCdList(prcsRoleTpCd, prevPrcsRoleTpCd));
                }
            },
            onError: (error) => {
                errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        getInscAtcmList: useFetch({
            api: (page = grid.appDtlInscAtcm.page) => {
                return APIS.getInscAtcmList({ ...params.appInfo }, page, grid.appDtlInscAtcm.size);
            },
            key: [grid.appDtlInscAtcm.page, grid.appDtlInscAtcm.size],
            onSuccess: (data) => {
                if (data.atcmList.content!) {
                    setAtcmList(comnUtils.getGridData(data.atcmList.content));
                    if (data.atcmList.content.length > 0) {
                        setAtcmVisible(true);
                    }
                }
            },
            onError: () => {},
            showToast: false,
        }),
        saveAppAprvRslt: useFetch({
            api: (data) => {
                return APIS.saveAppAprvRslt({ ...data });
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        handler.setInit();
                    },
                    onClose: () => {
                        handler.setInit();
                    },
                });
            },
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        sbmtAppAprvRslt: useFetch({
            api: (data) => {
                return APIS.sbmtAppAprvRslt({ ...data });
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        modal.postMessage({ rslt: "sbmt" });
                    },
                    onClose: () => {
                        modal.postMessage({ rslt: "sbmt" });
                    },
                });
            },
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
    };

    /*
     * Application Item Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            await form.appDtlAprvInfo.setValues(params.appInfo);
            await handler.getAppAprvInfo();
            if ("EF" != params.appInfo.appStatCd) {
                handler.getInscAtcmList();
            }
        },
        getAppAprvInfo: async () => {
            fetch.getAppAprvInfo.fetch(params.appInfo);
        },
        // Get Application Inspection Attachment List !== 신청서 검사 첨부파일 목록 조회 ==!
        getInscAtcmList: (page: number = 0) => {
            grid.appDtlInscAtcm.setPage(page);
            fetch.getInscAtcmList.fetch(page);
        },
        // Registration validation of application verification results !== 신청서 심사결과 등록 유효성 검사 ==!
        validateRgstAprvRslt: async (type: any) => {
            const chkRslt = await form.appRgstAprvRslt.validate();

            if (chkRslt) {
                form.appRgstAprvRslt.setValue("reffId", params.appInfo.appId);
                const data = { ...form.appRgstAprvRslt.getValues() };
                data.amdTpCd = params.appInfo.amdTpCd;

                if (type == "save") {
                    modal.openModal({
                        content: "msg.osc.00090",
                        onConfirm: () => {
                            fetch.saveAppAprvRslt.fetch(data);
                        },
                    });
                } else if (type == "sbmt") {
                    modal.openModal({
                        content: "msg.osc.00092",
                        onConfirm: () => {
                            fetch.sbmtAppAprvRslt.fetch(data);
                        },
                    });
                }
            }
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_APRV_RSTS"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.appDtlAprvInfo.schema.appNo} />
                                <Group.Control {...form.appDtlAprvInfo.schema.ucrNo} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlAprvInfo.schema.appNm} />
                                <Group.Control {...form.appDtlAprvInfo.schema.sbmtDtm} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control
                                    {...form.appRgstAprvRslt.schema.prcssStatCd}
                                    controlSize={10}
                                    excludes={excludeAuditCode}
                                />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appRgstAprvRslt.schema.prcssRsnCn} controlSize={10} />
                            </Group.Row>

                            {exmpnTaxVisible && (
                                <Group.Row>
                                    <Group.Control {...form.appRgstAprvRslt.schema.exmpnTaxTpCd} controlSize={10} />
                                </Group.Row>
                            )}

                            <Group.Row>
                                <Group.Control {...form.appRgstAprvRslt.schema.rmrk} controlSize={10} />
                            </Group.Row>
                        </Group.Section>
                    </Layout>
                    <Layout direction="row">
                        <Layout.Right>
                            <Button
                                role="save"
                                onClick={() => {
                                    handler.validateRgstAprvRslt("save");
                                }}
                            />
                            {sbmtVisible && (
                                <Button
                                    role="submit"
                                    onClick={() => {
                                        handler.validateRgstAprvRslt("sbmt");
                                    }}
                                >
                                    {t("L_CFRM")}
                                </Button>
                            )}
                        </Layout.Right>
                    </Layout>
                    {atcmVisible && (
                        <Layout direction="col">
                            <Layout>
                                <Group.Title title={"T_ATCM"} titleSize={2}></Group.Title>
                                <Layout direction="row">
                                    <Layout.Left></Layout.Left>
                                    <Layout.Right></Layout.Right>
                                </Layout>
                            </Layout>

                            <Group>
                                <Group.Body>
                                    <Grid {...grid.appDtlInscAtcm.grid} data={atcmList} />
                                </Group.Body>
                            </Group>
                        </Layout>
                    )}
                </Group.Body>
            </Group>
        </Page>
    );
};
